import Router from 'next/router';
import { faro } from '@grafana/faro-web-sdk';
import { LoginDataAction } from '@reducers/LoginDataReducer';
import { setCookie, delCookie, getCookie } from '@utils/cookieUtils';
import { getBeforeLoginCode } from '@utils/LoginProcess/requests';
import { LoginErrorCode, LoginErrorMessage, LoginStrategy } from '@utils/LoginProcess/constants';

export const getBeforeLoginCodeCallback = (
    response,
    loginData,
    loginDataDispatch,
) => {
    const { loginGuid, loginCodeImgBase64 } = response;

    loginDataDispatch({
        type: LoginDataAction.SET_LOGIN_CODE_IMAGE,
        payload: { loginCodeImage: loginCodeImgBase64 },
    });
    loginDataDispatch({
        type: LoginDataAction.UPDATE_LOGIN_DATA,
        payload: {
            key: 'loginGuid',
            value: loginGuid,
        },
    });
};

const setUserNameList = (username) => {
    const userNameList = getCookie('UserName') && !getCookie('UserNameList')
        ? getCookie('UserName') : getCookie('UserNameList');
    const gestureUsers = userNameList && userNameList.split(',');
    const gesList = getCookie('ges') || '';
    const getGesList = gesList.split(',');
    const checkListHasUser = gestureUsers.includes(username);
    if (!checkListHasUser && getGesList.includes(username)) {
        const newUserNameList = [...gestureUsers, username];
        setCookie('UserNameList', newUserNameList, 365);
    }
};

const getUserNameInCookie = () => {
    return getCookie('UserName');
};

const setUserNameInCookie = (userName) => {
    let uNames = getUserNameInCookie();

    if (uNames && uNames !== '') {
        uNames = uNames.split(',');
    } else {
        uNames = [];
    }
    const arrIdx = uNames.indexOf(userName);
    if (arrIdx >= 0) {
        uNames.splice(arrIdx, 1);
    }

    uNames.unshift(userName);

    setCookie('UserName', uNames.join(','), 365);
};

const setLanguageInCookie = (language) => {
    setCookie('LangKey', language, 3650);
    // for mobile
    setCookie('LANGUAGE_I18N', language, 3650);
};

export const LoginProcess = (
    rule,
    response,
    loginData,
    loginDataDispatch,
    locale,
    ip,
    isGestureLogin,
    t,
    scb,
    fcb,
    getGestureUsers,
    setLoginMode,
    checkRememberMe,
    clientApiUrl,
) => {
    return {
        // 0
        [LoginStrategy.Finish]: (loginInfo) => {
            setCookie('rememberMe', checkRememberMe, 365);
            if (!checkRememberMe) {
                delCookie('UserName');
                delCookie('ges');
                delCookie('nges');
                delCookie('gesTip');
            }
            if (checkRememberMe) {
                // setUserNameList(loginData.username);
                setUserNameInCookie(loginData.username);
                setLanguageInCookie(loginData.language);
            }
            if (isGestureLogin) {
                scb();
                // setUserNameList(loginData.username);
                setUserNameInCookie(loginData.username);
            }
            if (loginInfo.redirectUrl) {
                Router.push(loginInfo.redirectUrl);
            }
        },
        // 2
        [LoginStrategy.IncorrectUsernamePassword]: (loginInfo) => {
            loginDataDispatch({
                type: LoginDataAction.UPDATE_LOGIN_DATA,
                payload: {
                    key: 'password',
                    value: '',
                },
            });
            let errorMessage = {
                errorMessage: LoginErrorMessage.IncorrectUsernamePassword,
            };
            // lastChangePwdDate is GMT -4 and value is like 2025-05-05T02:02:19.313
            // convert to user local time zone
            // display yyyy-mm-dd
            if (loginInfo.lastChangePwdDate) {
                const sourceDate = new Date(loginInfo.lastChangePwdDate);
    
                // 源时区是GMT-4，即UTC-4
                const sourceTimezoneOffset = -4 * 60;
                
                // 获取用户本地时区的偏移量（分钟）
                const localTimezoneOffset = new Date().getTimezoneOffset();
                
                // 计算时区差（分钟）
                const timeDifference = localTimezoneOffset - sourceTimezoneOffset;
                
                // 调整日期（减去时区差，因为getTimezoneOffset返回的是相对于UTC的负值）
                const adjustedDate = new Date(sourceDate.getTime() - timeDifference * 60 * 1000);
                
                // 格式化为yyyy-mm-dd
                const year = adjustedDate.getFullYear();
                const month = String(adjustedDate.getMonth() + 1).padStart(2, '0');
                const day = String(adjustedDate.getDate()).padStart(2, '0');
                const userOldpwdChangeDate = `${year}-${month}-${day}`;

                errorMessage = {
                    errorMessage: LoginErrorMessage.IncorrectUsernamePasswordWithOldPassword,
                    replacedText: userOldpwdChangeDate,
                };
            } else if (loginInfo.loginCount>=3) {
                errorMessage = {
                    errorMessage: LoginErrorMessage.IncorrectUsernamePasswordWithErrorCount,
                    replacedText: loginInfo.loginCount,
                };
            }
            loginDataDispatch({
                type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                payload: {
                    errorMessage
                },
            });
        },
        // 41
        [LoginStrategy.IncorrectGesturePassword]: (loginInfo) => {
            const errorMessage = t(
                [LoginErrorMessage.IncorrectGesturePassword],
                { 0: 6 - loginInfo.gestureFailCnt },
            );
            fcb(loginInfo.errorCode, errorMessage);
        },
        // 4
        [LoginStrategy.TicketIdIsZero]: (loginInfo) => {
            if (isGestureLogin) {
                const errorMessage = t([LoginErrorMessage.TicketIdIsZero]);
                fcb(loginInfo.errorCode, errorMessage);
            } else {
                loginDataDispatch({
                    type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                    payload: {
                        errorMessage: {
                            errorMessage: LoginErrorMessage.TicketIdIsZero,
                        },
                    },
                });
            }
        },
        // 20
        [LoginStrategy.AccountClosed]: (loginInfo) => {
            if (isGestureLogin) {
                const errorMessage = t([LoginErrorMessage.AccountClosed]);
                fcb(loginInfo.errorCode, errorMessage);
            } else {
                loginDataDispatch({
                    type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                    payload: {
                        errorMessage: {
                            errorMessage: LoginErrorMessage.AccountClosed,
                        },
                    },
                });
            }
        },
        // 22
        [LoginStrategy.AccountSuspend]: (loginInfo) => {
            if (isGestureLogin) {
                scb();
            }
            if (loginInfo.redirectUrl) {
                Router.push(loginInfo.redirectUrl);
            }
        },
        // 398
        [LoginStrategy.Validation]: () => {
            loginDataDispatch({
                type: LoginDataAction.UPDATE_LOGIN_DATA,
                payload: {
                    key: 'password',
                    value: '',
                },
            });
            loginDataDispatch({
                type: LoginDataAction.NOT_SHOWING_ERROR_MESSAGE,
            });
            loginDataDispatch({
                type: LoginDataAction.NOT_SHOWING_GESTURE_LOGIN_FORM,
            });
            getBeforeLoginCode(clientApiUrl)
                .then((data) => (getBeforeLoginCodeCallback(data, loginData, loginDataDispatch)))
                .catch((error) => console.error(error));
        },
        // 23
        [LoginStrategy.AccountNoCredit]: () => {
            loginDataDispatch({
                type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                payload: {
                    errorMessage: {
                        errorMessage: LoginErrorMessage.AccountNoCredit,
                    },
                },
            });
        },
        // 24
        [LoginStrategy.AccountLocked]: (loginInfo) => {
            if (isGestureLogin) {
                const errorMessage = t([LoginErrorMessage.AccountLocked]);
                fcb(loginInfo.errorCode, errorMessage);
            } else {
                loginDataDispatch({
                    type: LoginDataAction.UPDATE_LOGIN_DATA,
                    payload: {
                        key: 'password',
                        value: '',
                    },
                });
                loginDataDispatch({
                    type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                    payload: {
                        errorMessage: {
                            errorMessage: LoginErrorMessage.AccountLocked,
                        },
                    },
                });
            }
        },
        // 401
        [LoginStrategy.GestureClosed]: (loginInfo) => { // 登入錯誤 6 次 401
            const gesUsers = getGestureUsers();
            if (loginInfo.userName) {
                const idxName = gesUsers.indexOf(loginInfo.userName.toLowerCase());
                if (idxName >= 0) {
                    gesUsers.splice(idxName, 1);
                }
            }
            if (loginInfo.nickname) {
                const idxNName = gesUsers.indexOf(loginInfo.nickname.toLowerCase());
                if (idxNName >= 0) {
                    gesUsers.splice(idxNName, 1);
                }
            }
            setCookie('ges', gesUsers.join(','));
            fcb(loginInfo.errorCode, t([LoginErrorMessage.GestureClosed]));
        },
        // 402
        [LoginStrategy.GesturepwdIsNull]: () => { // DB pwd null 402
            delCookie('ges');
            delCookie('nges');
            delCookie('gesTip');
            setLoginMode('keypad');
        },
        // 113
        [LoginStrategy.NotSupportGesture]: () => {
            delCookie('ges');
            delCookie('nges');
            delCookie('gesTip');
            setLoginMode('keypad');
        },
        // 45
        [LoginStrategy.LoginTooOften]: (loginInfo) => {
            if (isGestureLogin) {
                const errorMessage = t([LoginErrorMessage.LoginTooOften]);
                fcb(loginInfo.errorCode, errorMessage);
            } else {
                loginDataDispatch({
                    type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                    payload: {
                        errorMessage: {
                            errorMessage: LoginErrorMessage.LoginTooOften,
                        },
                    },
                });
            }
        },
        // 50
        [LoginStrategy.UnallowedLocation]: (loginInfo) => {
            if (isGestureLogin) {
                const errorMessage = `${
                    t(
                        LoginErrorMessage.UnallowedLocation,
                        {
                            0: loginInfo?.requestIp,
                            1: loginData.username,
                        },
                    )}`;
                fcb(loginInfo.errorCode, errorMessage);
            } else {
                loginDataDispatch({
                    type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                    payload: {
                        errorMessage: {
                            errorMessage: LoginErrorMessage.UnallowedLocation,
                            replacedText: loginInfo?.requestIp,
                            replacedText1: loginData.username,
                        },
                    },
                });
            }
        },
        // 101
        [LoginStrategy.UnderMaintenance]: (loginInfo) => {
            if (isGestureLogin) {
                const errorMessage = t([LoginErrorMessage.UnderMaintenance]);
                fcb(loginInfo.errorCode, errorMessage);
            } else {
                loginDataDispatch({
                    type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                    payload: {
                        errorMessage: {
                            errorMessage: LoginErrorMessage.UnderMaintenance,
                        },
                    },
                });
            }
        },
        // 408
        [LoginStrategy.RedirectRulesPage]: (loginInfo) => {
            loginDataDispatch({
                type: LoginDataAction.UPDATE_LOGIN_DATA,
                payload: {
                    key: 'redirectUrl',
                    value: loginInfo.redirectUrl,
                },
            });
            loginDataDispatch({
                type: LoginDataAction.TOGGLE_SHOWING_MEMBER_RULES,
                payload: {
                    isShowMemberRules: true,
                },
            });
        },
        // 25
        [LoginStrategy.WrongDomain]: (loginInfo) => {
            if (isGestureLogin) {
                const errorMessage = t(LoginErrorMessage.WrongDomain, { 0: loginInfo.errorCode });
                fcb(loginInfo.errorCode, errorMessage);
            } else {
                loginDataDispatch({
                    type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                    payload: {
                        errorMessage: {
                            errorMessage: LoginErrorMessage.WrongDomain,
                            replacedText: loginInfo.errorCode,
                        },
                    },
                });
            }
        },
        // 30
        [LoginStrategy.InvalidRoleId]: (loginInfo) => {
            if (isGestureLogin) {
                const errorMessage = t(LoginErrorMessage.InvalidRoleId, { 0: loginInfo.errorCode });
                fcb(loginInfo.errorCode, errorMessage);
            } else {
                loginDataDispatch({
                    type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                    payload: {
                        errorMessage: {
                            errorMessage: LoginErrorMessage.InvalidRoleId,
                            replacedText: loginInfo.errorCode,
                        },
                    },
                });
            }
        },
        // 40
        [LoginStrategy.IncorrectUnPw]: (loginInfo) => {
            if (isGestureLogin) {
                const errorMessage = t(LoginErrorMessage.IncorrectUnPw, { 0: loginInfo.errorCode });
                fcb(loginInfo.errorCode, errorMessage);
            } else {
                loginDataDispatch({
                    type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                    payload: {
                        errorMessage: {
                            errorMessage: LoginErrorMessage.IncorrectUnPw,
                            replacedText: loginInfo.errorCode,
                        },
                    },
                });
            }
        },
        // 43
        [LoginStrategy.UpdateCustomerStatusToCasinoAdminDBFailed]: (loginInfo) => {
            if (isGestureLogin) {
                const errorMessage = t(
                    LoginErrorMessage.UpdateCustomerStatusToCasinoAdminDBFailed,
                    { 0: loginInfo.errorCode },
                );
                fcb(loginInfo.errorCode, errorMessage);
            } else {
                loginDataDispatch({
                    type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                    payload: {
                        errorMessage: {
                            errorMessage: LoginErrorMessage.UpdateCustomerStatusToCasinoAdminDBFailed,
                            replacedText: loginInfo.errorCode,
                        },
                    },
                });
            }
        },
        // 102
        [LoginStrategy.RequestBodyHasNullValue]: (loginInfo) => {
            if (isGestureLogin) {
                const errorMessage = t(
                    LoginErrorMessage.RequestBodyHasNullValue,
                    { 0: loginInfo.errorCode },
                );
                fcb(loginInfo.errorCode, errorMessage);
            } else {
                loginDataDispatch({
                    type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                    payload: {
                        errorMessage: {
                            errorMessage: LoginErrorMessage.RequestBodyHasNullValue,
                            replacedText: loginInfo.errorCode,
                        },
                    },
                });
            }
        },
        // 394
        [LoginStrategy.RobotBlockOver5]: (loginInfo) => {
            if (isGestureLogin) {
                const errorMessage = t(
                    LoginErrorMessage.RobotBlockOver5,
                    { 0: loginInfo.errorCode },
                );
                fcb(loginInfo.errorCode, errorMessage);
            } else {
                loginDataDispatch({
                    type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                    payload: {
                        errorMessage: {
                            errorMessage: LoginErrorMessage.RobotBlockOver5,
                            replacedText: loginInfo.errorCode,
                        },
                    },
                });
            }
        },
        // 395
        [LoginStrategy.RefKeyCloseLoginIsTrue]: (loginInfo) => {
            if (isGestureLogin) {
                const errorMessage = t(
                    LoginErrorMessage.RefKeyCloseLoginIsTrue,
                    { 0: loginInfo.errorCode },
                );
                fcb(loginInfo.errorCode, errorMessage);
            } else {
                loginDataDispatch({
                    type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                    payload: {
                        errorMessage: {
                            errorMessage: LoginErrorMessage.RefKeyCloseLoginIsTrue,
                            replacedText: loginInfo.errorCode,
                        },
                    },
                });
            }
        },
        // 396
        [LoginStrategy.IsDeniedIp]: (loginInfo) => {
            if (isGestureLogin) {
                const errorMessage = `${
                    t(
                        LoginErrorMessage.IsDeniedIp,
                        {
                            0: loginInfo.errorCode,
                            1: loginInfo?.requestIp,
                        },
                    )}`;
                fcb(loginInfo.errorCode, errorMessage);
            } else {
                loginDataDispatch({
                    type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                    payload: {
                        errorMessage: {
                            errorMessage: LoginErrorMessage.IsDeniedIp,
                            replacedText: loginInfo.errorCode,
                            replacedText1: loginInfo?.requestIp,
                        },
                    },
                });
            }
        },
        // 397
        [LoginStrategy.LoginTooOftenPleaseWait5Minutes]: (loginInfo) => {
            if (isGestureLogin) {
                const errorMessage = t(
                    LoginErrorMessage.LoginTooOftenPleaseWait5Minutes,
                    { 0: loginInfo.errorCode },
                );
                fcb(loginInfo.errorCode, errorMessage);
            } else {
                loginDataDispatch({
                    type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                    payload: {
                        errorMessage: {
                            errorMessage: LoginErrorMessage.LoginTooOftenPleaseWait5Minutes,
                            replacedText: loginInfo.errorCode,
                        },
                    },
                });
            }
        },
        // 400
        [LoginStrategy.BadRequest]: (loginInfo) => {
            if (isGestureLogin) {
                const errorMessage = t(
                    LoginErrorMessage.BadRequest,
                    { 0: loginInfo.errorCode },
                );
                fcb(loginInfo.errorCode, errorMessage);
            } else {
                loginDataDispatch({
                    type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                    payload: {
                        errorMessage: {
                            errorMessage: LoginErrorMessage.BadRequest,
                            replacedText: loginInfo.errorCode,
                        },
                    },
                });
            }
        },
        // 407
        [LoginStrategy.NotInternalIp]: (loginInfo) => {
            if (isGestureLogin) {
                const errorMessage = t(
                    LoginErrorMessage.NotInternalIp,
                    { 0: loginInfo.errorCode },
                );
                fcb(loginInfo.errorCode, errorMessage);
            } else {
                loginDataDispatch({
                    type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                    payload: {
                        errorMessage: {
                            errorMessage: LoginErrorMessage.NotInternalIp,
                            replacedText: loginInfo.errorCode,
                        },
                    },
                });
            }
        },
        // 500
        [LoginStrategy.InternalServerError]: (loginInfo) => {
            if (isGestureLogin) {
                const errorMessage = t(
                    LoginErrorMessage.InternalServerError,
                    { 0: loginInfo.errorCode },
                );
                fcb(loginInfo.errorCode, errorMessage);
            } else {
                loginDataDispatch({
                    type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                    payload: {
                        errorMessage: {
                            errorMessage: LoginErrorMessage.InternalServerError,
                            replacedText: loginInfo.errorCode,
                        },
                    },
                });
            }
        },
        // 49
        [LoginStrategy.FailedCode]: (loginInfo) => {
            if (isGestureLogin) {
                const errorMessage = t(LoginErrorMessage.FailedCode, { 0: LoginErrorCode.FailedCode });
                fcb(loginInfo.errorCode, errorMessage);
            } else {
                loginDataDispatch({
                    type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                    payload: {
                        errorMessage: {
                            errorMessage: LoginErrorMessage.FailedCode,
                            replacedText: LoginErrorCode.FailedCode,
                        },
                    },
                });
            }
        },
        // Other error code
        [LoginStrategy.UnExceptError]: (loginInfo) => {
            if (isGestureLogin) {
                const errorMessage = t([LoginErrorMessage.FailedCode]);
                fcb(loginInfo.errorCode, errorMessage);
            } else {
                loginDataDispatch({
                    type: LoginDataAction.SHOWING_ERROR_MESSAGE,
                    payload: {
                        errorMessage: {
                            errorMessage: LoginErrorMessage.FailedCode,
                            replacedText: loginInfo.errorCode,
                        },
                    },
                });
            }
        },
    }[rule](response);
};

export const postLoginCallback = (
    clientApiUrl,
    response,
    loginData,
    loginDataDispatch,
    locale,
    ip,
    checkRememberMe,
    isGestureLogin,
    t,
    scb,
    fcb,
    getGestureUsers,
    setLoginMode,
) => {
    let rule = {
        [LoginErrorCode.Success]: LoginStrategy.Finish,
        [LoginErrorCode.IncorrectUsernamePassword]: LoginStrategy.IncorrectUsernamePassword,
        [LoginErrorCode.TicketIdIsZero]: LoginStrategy.TicketIdIsZero,
        [LoginErrorCode.AccountClosed]: LoginStrategy.AccountClosed,
        [LoginErrorCode.AccountSuspend]: LoginStrategy.AccountSuspend,
        [LoginErrorCode.LoginCountIsBiggerThanMaximumValue]: LoginStrategy.Validation,
        [LoginErrorCode.AccountNoCredit]: LoginStrategy.AccountNoCredit,
        [LoginErrorCode.AccountLocked]: LoginStrategy.AccountLocked,
        [LoginErrorCode.LoginTooOften]: LoginStrategy.LoginTooOften,
        [LoginErrorCode.UnallowedLocation]: LoginStrategy.UnallowedLocation,
        [LoginErrorCode.UnderMaintenance]: LoginStrategy.UnderMaintenance,
        [LoginErrorCode.RedirectRulesPage]: LoginStrategy.RedirectRulesPage,
        [LoginErrorCode.FailedCode]: LoginStrategy.FailedCode,
        // Gesture only
        [LoginErrorCode.IncorrectGesturePassword]: LoginStrategy.IncorrectGesturePassword,
        [LoginErrorCode.GestureClosed]: LoginStrategy.GestureClosed,
        [LoginErrorCode.GesturepwdIsNull]: LoginStrategy.GesturepwdIsNull,
        [LoginErrorCode.NotSupportGesture]: LoginStrategy.NotSupportGesture,
        // BackdoorLogin only
        [LoginErrorCode.NotInternalIp]: LoginStrategy.NotInternalIp,
        // 新增的
        [LoginErrorCode.WrongDomain]: LoginStrategy.WrongDomain,
        [LoginErrorCode.InvalidRoleId]: LoginStrategy.InvalidRoleId,
        [LoginErrorCode.IncorrectUnPw]: LoginStrategy.IncorrectUnPw,
        [LoginErrorCode.UpdateCustomerStatusToCasinoAdminDBFailed]:
            LoginStrategy.UpdateCustomerStatusToCasinoAdminDBFailed,
        [LoginErrorCode.RequestBodyHasNullValue]: LoginStrategy.RequestBodyHasNullValue,
        [LoginErrorCode.RobotBlockOver5]: LoginStrategy.RobotBlockOver5,
        [LoginErrorCode.RefKeyCloseLoginIsTrue]: LoginStrategy.RefKeyCloseLoginIsTrue,
        [LoginErrorCode.IsDeniedIp]: LoginStrategy.IsDeniedIp,
        [LoginErrorCode.LoginTooOftenPleaseWait5Minutes]: LoginStrategy.LoginTooOftenPleaseWait5Minutes,
        [LoginErrorCode.BadRequest]: LoginStrategy.BadRequest,
        [LoginErrorCode.InternalServerError]: LoginStrategy.InternalServerError,
    }[response.errorCode];

    rule = rule || LoginStrategy.UnExceptError;

    LoginProcess(
        rule,
        response,
        loginData,
        loginDataDispatch,
        locale,
        ip,
        isGestureLogin,
        t,
        scb,
        fcb,
        getGestureUsers,
        setLoginMode,
        checkRememberMe,
        clientApiUrl,
    );
};
